<mat-spinner *ngIf="loading">
</mat-spinner>
<mat-horizontal-stepper *ngIf="!loading" [selectedIndex]="stepIndex" class="wizard-background" linear="true" #stepper>
    <mat-step [editable]="!isReservationFinished" [completed]="reservationPatientCompleted">
        <div>
            <div class="card-container">
                <ng-template matStepLabel>Seleccione al paciente</ng-template>
                <app-reservation-patient-component #reservationPatientComponent></app-reservation-patient-component>
            </div>
        </div>
    </mat-step>
    <mat-step [editable]="!isReservationFinished" [completed]="reservationPracticeCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Cargue las prácticas</ng-template>
            <app-reservation-practice-component #reservationPracticeComponent></app-reservation-practice-component>
        </div>
    </mat-step>
    <mat-step [editable]="!isReservationFinished" [completed]="reservationPriceCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Documentación e importes</ng-template>
            <app-reservation-price-component #reservationPriceComponent></app-reservation-price-component>
        </div>
    </mat-step>
    <mat-step [editable]="!isReservationFinished" [completed]="reservationQuestionCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Condiciones</ng-template>
            <app-reservation-question-component #reservationQuestionComponent></app-reservation-question-component>
        </div>
    </mat-step>
    <mat-step [editable]="!isReservationFinished" [completed]="reservationCalendarCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Agenda</ng-template>
            <app-reservation-calendar-component #reservationCalendarComponent></app-reservation-calendar-component>
        </div>
    </mat-step>
    <mat-step [completed]="reservationPatientRequiredCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Paciente</ng-template>
            <app-reservation-patient-required-component #reservationPatientRequiredComponent></app-reservation-patient-required-component>
        </div>
    </mat-step>
    <mat-step [completed]="reservationOrderCompleted">
        <div class="card-container">
            <ng-template matStepLabel>Orden</ng-template>
            <app-reservation-order-component #reservationOrderComponent></app-reservation-order-component>
        </div>
    </mat-step>
</mat-horizontal-stepper>